import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=fe812b76&scoped=true&"
import script from "./notes.vue?vue&type=script&lang=js&"
export * from "./notes.vue?vue&type=script&lang=js&"
import style0 from "./notes.vue?vue&type=style&index=0&id=fe812b76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe812b76",
  null
  
)

export default component.exports